import { Component } from "react";
import React from "react";
import NewQuestionnaireRanking from "./NewQuestionnaireRanking";
import { deleteRanking } from "../../../../stores/actions/rankingAction";
import { connect } from "react-redux";
import { compose } from "redux";
import EditRankingInfo from "./EditRankingInfo";

class QuestionnaireRankingInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: null,
            selectedRankId: ''
        }
        this.childResetFunction = null;
    }

    componentDidUpdate(prevProps, prevState) {
        const { deleteRankingSuccess, deleteRankingError } = this.props;

        if (prevProps.deleteRankingError !== deleteRankingError) {
            this.setState({
                isLoading: false,
                message: {
                    msg: deleteRankingError.message,
                    type: deleteRankingError.type
                }
            })
        }

        if (prevProps.deleteRankingSuccess !== deleteRankingSuccess) {
            window.alert('Question Deleted Successfully!');
            this.setState({
                isLoading: false,
                message: {
                    msg: deleteRankingSuccess.message,
                    type: deleteRankingSuccess.type
                }
            });


        }
    }

    showRankingModalAdd = () => {
        document.getElementById('modal-add-ranking').style.display = 'block';
    }

    hideRankingModalAdd = () => {
        if(this.childResetFunction){
            this.childResetFunction()
        };
        
        document.getElementById('modal-add-ranking').style.display = 'none';
    }

    deleteRanking = (selectedRankId) => {
        // console.log(selectedRankId);
        const { ranking } = this.props;
        const rankingToDelete = ranking.find(//find the rank to be deleted from ranking props based on passed rankId
            rank => rank.id = selectedRankId
        )

        if (!rankingToDelete) {
            console.groupEnd('Rank not found', selectedRankId);
            return;
        }

        const confirmDelete = window.confirm(
            `Confirm Delete "${rankingToDelete.title}"?`
        );

        if (confirmDelete) {
            this.props.deleteRanking(selectedRankId);
        }
    }

    showRankingModalEdit = (selectedRankId) => {
        this.setState({ selectedRankId: selectedRankId })
        document.getElementById('modal-edit-ranking').style.display = 'block';
    }

    hideRankingModalEdit = () => {
        document.getElementById('modal-edit-ranking').style.display = 'none';
    }

    render() {
        const { ranking, schemes } = this.props;
        const { selectedRankId } = this.state;
        // console.log('props', this.props)
        // console.log('state', this.state)
        return (
            <>
                <div id="modal-add-ranking" className="mymodal">
                    <div className="mymodal-content col-md-6">
                        <span className="close" onClick={this.hideRankingModalAdd}>&times;</span>
                        <b className="uppercase">Add New Ranking
                            <div className="title-border"></div>
                        </b>
                        <NewQuestionnaireRanking schemes={schemes} hideRankingModalAdd={this.hideRankingModalAdd} onMountRegister={(resetFn) => this.childResetFunction = resetFn}/>
                    </div>
                </div>
                <div id="modal-edit-ranking" className="mymodal">
                    <div className="mymodal-content col-md-6">
                        <span className="close" onClick={this.hideRankingModalEdit}>&times;</span>
                        {/* <b className="uppercase">Add New Ranking
                            <div className="title-border"></div>
                        </b> */}
                        <EditRankingInfo ranking={ranking} schemes={schemes} hideRankingModalEdit={this.hideRankingModalEdit} selectedRankId={selectedRankId} />
                    </div>
                </div>
                <button className="btn btn-outline-black" onClick={this.showRankingModalAdd}>
                    <i className="fas fa-plus-circle" />{' '}Ranking
                </button>
                <table className="table">
                    <thead>
                        <tr>
                            <th className="col-md-1" scope="col">No.</th>
                            <th className="col-md-3">Title</th>
                            <th className="col-md-4">Rank Range&#40;%&#41;</th>
                            <th className="col-md-2">Schemes</th>
                            <th className="col-md-2">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ranking ? ranking.map((rank, rankIndex) =>
                        (<React.Fragment key={rankIndex}>
                            <tr>
                                <th scope="col">{rankIndex + 1}</th>
                                <td>
                                    {rank.title}
                                </td>
                                <td>
                                    {rank.minPercentage} - {rank.maxPercentage}
                                </td>
                                <td className="align-middle">
                                    <div className="d-flex flex-wrap">
                                        {rank.selectedSchemes.map((scheme, schemeIndex) =>
                                            <div className="col-md-3" key={schemeIndex}>{scheme.code}</div>
                                        )}
                                    </div>
                                </td>
                                <td className="align-middle">
                                    <i className="fas fa-edit mr-3" onClick={() => this.showRankingModalEdit(rank.id)} style={{ cursor: 'pointer' }}></i>
                                    <i className="fas fa-trash text-red" onClick={() => this.deleteRanking(rank.id)} style={{ cursor: 'pointer' }}></i>
                                </td>
                            </tr>
                        </React.Fragment>)
                        ) : (
                            <tr>
                                <td>No Data</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        deleteRankingSuccess: state.ranking.deleteRankingSuccess,
        deleteRankingError: state.ranking.deleteRankingError
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        deleteRanking: (rankingId) => dispatch(deleteRanking(rankingId))
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(QuestionnaireRankingInfo)